import { PropTypes } from "prop-types";
import { NavLink } from "react-router-dom";
import linksByGroup from "../../../constants/links";
import "./menu.scss";

const propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

const defaultProps = {
  user: null,
};

const Menu = ({ user, isOpen, setIsOpen }) => {
  const getLinks = () => {
    if (user) {
      const userGroups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      const linkGroup = Object.keys(linksByGroup).find((group) =>
        userGroups.includes(group)
      );
      return linksByGroup[linkGroup];
    }
    return linksByGroup.public;
  };

  return (
    <div className={`${isOpen ? "menu" : "hidden"}`}>
      {getLinks().map(({ href, label }) => (
        <div key={label}>
          <NavLink
            activeClassName="current-page"
            className="link-label"
            exact
            to={href}
            onClick={() => setIsOpen(false)}
          >
            {label}
          </NavLink>
        </div>
      ))}
    </div>
  );
};

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

export default Menu;
